import { encrypt } from '@/allotment/utils'

const user = JSON.parse(encrypt.decrypt(sessionStorage.getItem('user')) || '{}')

//当前登录用户变量
export default {
  state: {
    userId: user.userId || '',
    username: user.username || '',
    phone: user.phone || '',
    zipCode: user.zipCode || '',
    pushMail: user.pushMail || '',
    roles: user.roles || []
  },

  getters: {
    //获取当前登录用户角色标识
    role: state => {
      if(!state.roles || !state.roles.length) return ''
      return state.roles[0].code
    }
  },

  mutations: {
    //保存用户信息
    saveUser(state, value) {
      if(value) {
        state.userId = value.userId || ''
        state.username = value.username || ''
        state.phone = value.phone || ''
        state.zipCode = value.zipCode || ''
        state.pushMail = (value.pushMail || '0') + ''
        state.roles = value.roles || []

        sessionStorage.setItem('user', encrypt.encrypt(JSON.stringify(state)))
      }
    },

    //修改用户信息
    updateUser(state, value) {
      if(value) {
        if(value.userId != undefined) state.userId = value.userId || ''
        if(value.username != undefined) state.username = value.username || ''
        if(value.phone != undefined) state.phone = value.phone || ''
        if(value.zipCode != undefined) state.zipCode = value.zipCode || ''
        if(value.pushMail != undefined) state.pushMail = value.pushMail || ''
        if(value.roles != undefined) state.roles = value.roles || []

        sessionStorage.setItem('user', encrypt.encrypt(JSON.stringify(state)))
      }
    },

    //删除用户信息
    removeUser(state){
      state.userId = ''
      state.username = ''
      state.phone = ''
      state.zipCode = ''
      state.pushMail = ''
      state.roles = []

      sessionStorage.removeItem('user')
    }
  }
}
